<script lang="ts">
    import { AppShell, Drawer, getDrawerStore } from "@skeletonlabs/skeleton";
    import SidebarLeft from "$lib/components/SidebarLeft.svelte";
    import Hamburger from "$lib/assets/Hamburger.svg";
    import LogoTitle from "$lib/assets/LogoTitle.svg";

    const drawerStore = getDrawerStore();

    export let data;
</script>

<Drawer class="z-50" bgDrawer="variant-filled-primary" width="w-56">
    <SidebarLeft {data} />
</Drawer>

<AppShell
    slotHeader="variant-filled-primary relative sm:hidden"
    slotPageContent="variant-filled-surface sm:p-12 overflow-x-auto"
    slotSidebarLeft="variant-filled-primary w-56 xs:hidden"
>
    <svelte:fragment slot="header">
        <img class="size-14 p-3.5" src={Hamburger} on:click={() => drawerStore.open()} alt="View Menu" />
        <img class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 z-0 h-6" src={LogoTitle} alt="Arwin" />
    </svelte:fragment>

    <svelte:fragment slot="sidebarLeft">
        <SidebarLeft {data} />
    </svelte:fragment>

    <!-- Page Route Content -->
    <slot />
</AppShell>
